import {ApiClient} from '@hconnect/apiclient'
import {stringify} from 'qs'

import {ComparativeAnalysisDownloadPayload, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

const downloadComparativeAnalysisExcelImpl: RequestFunc<
  ComparativeAnalysisDownloadPayload,
  Blob
> = async ({startDate, endDate, hierarchyIds}) => {
  const {data} = await ApiClient.axiosInstance.get<Blob>(
    '/pom-questionnaires/analyses/hierarchy-comparison/excel-sheet',
    {
      params: {
        hierarchyIds,
        startDate,
        endDate
      },
      paramsSerializer: (params) => stringify(params, {arrayFormat: 'repeat'}),
      responseType: 'blob'
    }
  )

  return data
}

export const downloadComparativeAnalysisExcel = loggingDecorator(
  downloadComparativeAnalysisExcelImpl
)
